import { Grid, Typography } from "@mui/material";
import { ReactComponent as OrdersEmptyState } from 'assets/svg/IconOrdersEmptyState.svg'
import { Colors } from 'helpers/Consts'

function EmptyOrders() {
    return (
        <Grid container justifyContent='center'>
            <Grid item xs={12} sm={6} md={5}>
                <OrdersEmptyState height='35%' width='100%' />
                <Typography
                    sx={{ fontSize: '1.25rem' }}
                    textAlign='center'
                    color={Colors.baseTextColor}
                    fontWeight='500'
                >
                    Ops! Não há nada aqui.
                </Typography>
                <Typography
                    sx={{ fontSize: '0.8rem' }}
                    textAlign='center'
                    color={Colors.baseTextColor}
                >
                    Não encontramos nenhum pedido nesta seção.
                </Typography>
            </Grid>
        </Grid>
    )
}

export default EmptyOrders;